module.exports = {"body":"<p>Enhanced Interiors Remodeling can provide a solution for all the exterior work you\nhave in mind. Weather it is new siding and paint to address curb appeal, or new\nwindows and doors to make your home more energy efficient.</p>\n<p>No matter your needs, from Roofs to Custom patios and retaining walls, Enhanced interiors\nRemodeling will work for you.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./work/Exterior.md
// module id = 512
// module chunks = 0